<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="120px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>
                        <el-form-item label="Hashtag w nagłówku"
                                      :error="errors[addLanguageSuffix('header_hashtag')]">
                            <el-input v-model="form[addLanguageSuffix('header_hashtag')]"></el-input>
                        </el-form-item>
                        <el-form-item label="Data w nagłówku"
                                      :error="errors[addLanguageSuffix('header_date')]">
                            <el-input v-model="form[addLanguageSuffix('header_date')]"></el-input>
                        </el-form-item>
                        <el-form-item label="Data rozpoczęcia"
                                      :error="errors.start_date">
                            <el-date-picker type="date"
                                            format="yyyy/MM/dd"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Data rozpoczecia festiwalu"
                                            v-model="form.start_date"/>
                        </el-form-item>
                        <el-form-item label="Data zakończenia"
                                      :error="errors.end_date">
                            <el-date-picker type="date"
                                            format="yyyy/MM/dd"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Data zakończenia festiwalu"
                                            v-model="form.end_date"/>
                        </el-form-item>
                        <el-form-item label="Pokaż zegar odliczający do początku festiwalu">
                            <el-switch v-model="form.show_counting_down"></el-switch>
                        </el-form-item>
                        <el-form-item label="Domena z biletami"
                                      :error="errors.tickets_url">
                            <el-input v-model="form.tickets_url"
                                      placeholder="https://www.altersklep.pl"/>
                        </el-form-item>
                        <el-form-item label="Odnośnik do polityki prywatności"
                                      :error="errors.policy_link">
                            <link-component v-model="form.policy_link"
                                            :errors="errors['policy_link']"/>
                        </el-form-item>

                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {SiteSettings} from '@/api/';

    export default {
        data () {
            return {
                loading: false,
                form: {},
                errors: {},
                service: SiteSettings
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                this.service.get().then(response => {
                    this.form = response.data
                })
            },
            onSubmit () {
                this.loading = true;
                const service = this.service.update(this.form)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// SettingsForm.vue?4a35c526